import React from "react";
import { useComponentRegistry } from "../componentRegistry";
import type { CarFilterIdType } from "../../../../shared-logic/types/UscCommonTypes";

type Props = { filterId: CarFilterIdType };

const SidebarFilterWrapper = ({ filterId }: Props): JSX.Element => {
    const FilterWrapper = useComponentRegistry("FilterWrapper");

    return <FilterWrapper filterId={filterId} />;
};

export default SidebarFilterWrapper;
